// (c) 2020, SAS Institute Inc.

// Common header names to prevent magic strings in code.

export let HeaderName = /*#__PURE__*/function (HeaderName) {
  HeaderName["Accept"] = "Accept";
  HeaderName["AcceptItem"] = "Accept-Item";
  HeaderName["ContentType"] = "Content-Type";
  HeaderName["ETag"] = "ETag";
  HeaderName["IfMatch"] = "If-Match";
  HeaderName["IfModifiedSince"] = "If-Modified-Since";
  HeaderName["IfNoneMatch"] = "If-None-Match";
  HeaderName["IfUnmodifiedSince"] = "If-Unmodified-Since";
  HeaderName["RequestedWith"] = "X-Requested-With";
  HeaderName["SASApplicationName"] = "sas-application-name";
  HeaderName["SASRequest"] = "SAS-Request";
  HeaderName["UnauthorizedReason"] = "X-Unauthorized-Reason";
  return HeaderName;
}({});
//# sourceMappingURL=HeaderName.js.map